module.exports = __webpack_public_path__ + "img/melia-beach-2.e900239c.jpg";